import { createClient } from "@supabase/supabase-js"; 

const { REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY } = process.env;
export const supabase = createClient(REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_KEY); 

export const bloques_horarios = ["09:00", "10:00", "11:00", "12:00", "13:00"];

export const validarTelefono = (valor) => {
  const regex = /^[6789]\d{8}$/;
  return regex.test(valor);
};

export const sumarUnaHora = (horaStr) => {
  const [hora, minuto] = horaStr.split(":").map(Number);
  const nuevaHora = (hora + 1) % 24;
  return `${String(nuevaHora).padStart(2, "0")}:${String(minuto).padStart(2, "0")}`;
};

export const formatFechaKey = (date) => {
  return (
    date.getFullYear() + "-" +
    String(date.getMonth() + 1).padStart(2, "0") + "-" +
    String(date.getDate()).padStart(2, "0")
  );
};

export const fetchCitasPorDia = async () => {
  const { data, error } = await supabase
    .from("citas")
    .select("fecha")
    .eq("confirmada", true);

  if (error) {
    console.error("Error al obtener citas:", error);
    return {};
  }
  if (!data || data.length === 0) return {};

  const conteo = {};
  data.forEach(({ fecha }) => {
    conteo[fecha] = (conteo[fecha] || 0) + 1;
  });
  return conteo;
};

export const fetchCitasPorFecha = async (fecha) => {
  const fechaISO = formatFechaKey(new Date(fecha));

  const { data, error } = await supabase
    .from("citas")
    .select("hora")
    .eq("confirmada", true)
    .gte("hora", `${fechaISO}T00:00:00`)
    .lt("hora", `${fechaISO}T23:59:59`);

  if (error) {
    console.error("Error al obtener citas del día:", error);
    return [];
  }
  return data;
};

export const fetchDiasExcepcion = async () => {
  const { data, error } = await supabase
    .from("dias_laborables")
    .select("fecha, es_excepcion");

  if (error) {
    console.error("Error al obtener días excepción:", error);
    return [];
  }
  return data;
};

export const esDiaLaborable = (date, listaExcepciones) => {
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  const manana = new Date(hoy);
  manana.setDate(manana.getDate() + 1);

  const fechaLimite = new Date(hoy.getFullYear(), hoy.getMonth() + 3, 0);

  if (date < manana || date > fechaLimite) return false;

  const diaSemana = date.getDay();
  const esFinDeSemana = [5, 6, 0].includes(diaSemana);
  const key = formatFechaKey(date);

  const excepcion = listaExcepciones.find((f) => f.fecha === key);

  let esLaborable = esFinDeSemana;
  if (excepcion && excepcion.es_excepcion === true) {
    esLaborable = !esFinDeSemana;
  }
  return esLaborable;
};

export const buscarProximaDisponibilidad = async (conteoActual, listaExcepciones) => {
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const fechaLimite = new Date(hoy.getFullYear(), hoy.getMonth() + 3, 0);

  const fechaIteracion = new Date(hoy);
  fechaIteracion.setDate(fechaIteracion.getDate() + 1);

  while (fechaIteracion <= fechaLimite) {
    if (esDiaLaborable(fechaIteracion, listaExcepciones)) {
      const fechaKey = formatFechaKey(fechaIteracion);
      const citasEnDia = conteoActual[fechaKey] || 0;

      if (citasEnDia < bloques_horarios.length) {
        return new Date(fechaIteracion);
      }
    }
    fechaIteracion.setDate(fechaIteracion.getDate() + 1);
  }
  return null;
};